export default __webpack_public_path__ + "static/missionme_logo_full-9a0f385ff67a012683c52110a1d85f2b.svg";